gsap.registerPlugin(ScrollTrigger);
// ==================================================================================== SECTION 1
gsap.set('.co-about-section-1-ani-obj', { transition: 0, opacity: 0, x: 20 });
gsap.to('.co-about-section-1-ani-obj', {
  x: 0, opacity: 1, ease: "power1.inOut", duration: 1, stagger: 0.1
});
// SCROLL
gsap.set('.co-about-section-1-ani-obj-1>div', { y: "0%", transition: 0 });
gsap.to('.co-about-section-1-ani-obj-1>div', {
  scrollTrigger: {
    trigger: 'body', endTrigger: '.co-about-section-1', start:'top top', end: "bottom top", scrub: 1.05
  },
  y: "10%"
});
gsap.set('.co-about-section-1-ani-obj-2>div', { y: "0%", transition: 0 });
gsap.to('.co-about-section-1-ani-obj-2>div', {
  scrollTrigger: {
    trigger: 'body', endTrigger: '.co-about-section-1', start:'top top', end: "bottom top", scrub: 1.05
  },
  y: "-10%"
});
gsap.set('.co-about-section-1-ani-obj-3>div', { y: "0%", transition: 0 });
gsap.to('.co-about-section-1-ani-obj-3>div', {
  scrollTrigger: {
    trigger: 'body', endTrigger: '.co-about-section-1', start:'top top', end: "bottom top", scrub: 1.05
  },
  y: "3%"
});
gsap.set('.co-about-section-1-ani-obj-4>div', { x: "0%", transition: 0 });
gsap.to('.co-about-section-1-ani-obj-4>div', {
  scrollTrigger: {
    trigger: 'body', endTrigger: '.co-about-section-1', start:'top top', end: "bottom top", scrub: 1.05
  },
  x: "3%"
});
gsap.set('.co-about-section-1-ani-obj-5>div', { y: "0%", transition: 0 });
gsap.to('.co-about-section-1-ani-obj-5>div', {
  scrollTrigger: {
    trigger: 'body', endTrigger: '.co-about-section-1', start:'top top', end: "bottom top", scrub: 1.05
  },
  y: "5%"
});
// ==================================================================================== SECTION 3
// SLIDER
new Flickity( '.co-about-section-3-carousel', {
    cellAlign: "left",
    groupCells: true,
    contain: true,
    prevNextButtons: true,
    pageDots: false,
    freeScroll: true,
    // wrapAround: true,
    // autoPlay: 3000,
    on: {
      ready: function() {

      }
    }
  });